export const CHANNEL_NAME = 'auth_channel';

export const FAILED_AUTH_MESSAGE = 'AUTH_FAILED';

export const AUTH_SHOWN_STORAGE_KEY = 'authShown';
